module.exports = __webpack_public_path__ + "img/1.3543f708.jpg";